import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { usePayPalScriptReducer, DISPATCH_ACTION, PayPalButtons } from '@paypal/react-paypal-js';
import { Loader } from '@grandvisionhq/common';
import '@grandvisionhq/utils';
import '../../../../context/PaymentsUI/context.js';
import { usePaypalClientConfiguration } from '../../../../context/Paypal/PaypalClientConfigurationContext.js';
import '../../../../models/adyen/payment-type.js';
import '../../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../../models/googlePay/types.js';
import '../../../../models/payment/types.js';
import { Intent } from '../../../../models/paypal/context.js';

const PaypalActionButton = ({ orderType , events , disabled , layout ='horizontal'  })=>{
    const [{ isPending , options  }, dispatch] = usePayPalScriptReducer();
    const paypalConfig = usePaypalClientConfiguration();
    React.useEffect(()=>{
        if (dispatch && orderType === 'subscription') {
            dispatch({
                type: DISPATCH_ACTION.RESET_OPTIONS,
                value: swcHelpers.objectSpread({}, options, {
                    intent: Intent.TOKENIZE,
                    vault: true
                })
            });
        }
    // Options and dispatch are not stable and cause rerenders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        orderType
    ]);
    const paypalButtonStyle = React.useMemo(()=>{
        return swcHelpers.objectSpread({
            label: 'paypal',
            layout,
            tagline: false,
            shape: (paypalConfig === null || paypalConfig === void 0 ? void 0 : paypalConfig.buttonShape) || 'rect',
            disableMaxWidth: true
        }, (paypalConfig === null || paypalConfig === void 0 ? void 0 : paypalConfig.buttonShape) === 'rect' ? {
            borderRadius: 6
        } : {}, {
            height: 48
        });
    }, [
        layout,
        paypalConfig === null || paypalConfig === void 0 ? void 0 : paypalConfig.buttonShape
    ]);
    if (isPending) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    return /*#__PURE__*/ React.createElement(PayPalButtons, swcHelpers.extends({
        className: "paypal-psp-action",
        "data-t": "paypal-with-paypal-pay-action",
        disabled: disabled,
        onError: events.onError || console.error,
        style: paypalButtonStyle
    }, events));
};

export { PaypalActionButton };
//# sourceMappingURL=PaypalActionButton.js.map
